const StatusCircle = ({ variant }) => (
  <div className={`status-circle ${variant ? `status-circle--${variant}` : 'status-circle--default'}`} />
)

export default StatusCircle
